module.exports = __webpack_public_path__ + "img/frame-icon_2.ce69955.png";